module.exports = __webpack_public_path__ + "img/image-thumb-11.3a6b216e.jpg";